import toast from "react-hot-toast";

export const MEMBER_SUBSCRIPTION_EXPIRED = "MEMBER_SUBSCRIPTION_EXPIRED";
export const ONE_ACTIVE_BOOKING_RESTRICTION = "ONE_ACTIVE_BOOKING_RESTRICTION";
export const BOOKING_RESTRICTION_EXPIRED_EVENT = "booking-restriction-expired";
export const BOOKING_RESTRICTION_ACTIVE_BOOKING_EVENT = "booking-restriction-active-booking";

// Shows the PrivateClubWorld Member Subscription booking errors the same way for
// every Create_booking caller. Returns true when the response was one of them.
export const handleBookingRestriction = (response) => {
  const errorCode = response?.errors?.error_code;

  if (errorCode === MEMBER_SUBSCRIPTION_EXPIRED) {
    window.dispatchEvent(new Event(BOOKING_RESTRICTION_EXPIRED_EVENT));
    return true;
  }
  if (errorCode === ONE_ACTIVE_BOOKING_RESTRICTION) {
    toast.error(response?.message || "Something Went Wrong!!!");
    return true;
  }
  return false;
};
